export const validatePurchaseFields = (formFieldsData: any, setFormFieldsErrors: any) => {
    let fieldErrors: any
    if (!formFieldsData?.supplier) {
        fieldErrors = {
            ...(fieldErrors || {}),
            supplier: 'Supplier is required'
        }
    }
    if (!formFieldsData?.expectedDeliveryDate) {
        fieldErrors = {
            ...(fieldErrors || {}),
            expectedDeliveryDate: 'Expected Date is required'
        }
    }

    if (!formFieldsData?.currency) {
        fieldErrors = {
            ...(fieldErrors || {}),
            currency: 'Currency is required'
        }
    }

    if (fieldErrors) {
        setFormFieldsErrors(fieldErrors)
        return false
    }
    else {
        setFormFieldsErrors(undefined)
        return true
    }
}